const initialState = {
  isLoading: false,
  payout: {},
  payoutfiles: { usr: { rec: [] } },
  payoutfilesd: {},
  newUser: {},
  currentData: {},
  details: {},
  errors: null,
};

const payoutReducer = (state = initialState, action) => {
  switch (action.type) {

    case "payout_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "payout_List_Success":
      return {
        ...state,
        isLoading: false,

        payout: action.payload,
      };
    case "payout_List_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };

      case "payout_FileList_req":
      return {
        ...state,
        isLoading: true,
      };
    case "payout_FileList_Success":
      return {
        ...state,
        isLoading: false,
        payoutfiles: action.payload,
      };
    case "payout_FileList_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };

       
      case "upd_payoutFiles_req":
        return {
          ...state,
          isLoading: true,
        };
      case "upd_payoutFiles_Success":
        return {
          ...state,
          isLoading: false,
          payoutfiles: action.payload,
        };
      case "upd_payoutFiles_failure":
        return {
          ...state,
          isLoading: false,
          errors: action.payload,
        };


        case "upd_payoutFiles_req2":
        return {
          ...state,
          isLoading: true,
        };
      case "upd_payoutFiles_Success2":
        return {
          ...state,
          isLoading: false,
          payoutfilesd: action.payload,
        };
      case "upd_payoutFiles_failure2":
        return {
          ...state,
          isLoading: false,
          errors: action.payload,
        };

    case "payout_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "payout_delete":
      return {
        ...state,
        isLoading: false,

        payout: action.payload,
      };
    case "payout_delete_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "add_payout_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_payout_success":
      return {
        ...state,
        isLoading: false,

        newUser: action.payload,
      };
    case "add_payout_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "edit_payout_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_payout_success":
      return {
        ...state,
        isLoading: false,

        newUser: action.payload,
      };

    case "edit_payout_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "set_payout_details":
      return {
        ...state,
        laoding: false,
        currentData: action.payload,
      };
    case "reset_payout_details":
      return {
        ...state,
        laoding: false,
        currentData: {},
        newUser: {}
      };

    default:
      return state;
  }
};

export { payoutReducer };
